import { withLocaleInURI } from "../internationalization/i18nURI";

export function YiiUrlFactory(path: string, locale: string): string {
  if (!locale) {
    console.warn(`No locale set for URL ${path}`);
  }
  return withLocaleInURI(path, locale);
}
